export default __webpack_public_path__ + "static/media/rocket_anim_62.7201bed7.png";